import { render, staticRenderFns } from "./ReceiptDetailsPage.vue?vue&type=template&id=3dba9cd0&scoped=true&"
import script from "./ReceiptDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ReceiptDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptDetailsPage.vue?vue&type=style&index=0&id=3dba9cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba9cd0",
  null
  
)

export default component.exports